module.exports = __webpack_public_path__ + "img/header-icon1.9953b382.jpg";